import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchfilterplan'
})

/**
 * Searches text of name, created by user name properties of a collection of Plans and returns any that contain the search text
 * @param {any[]} plans - collection of Plans
 * @param {string} searchText - text to search by
 * @returns {any[]} - filtered collection of Plans
 */
@Injectable()
export class SearchFilterPlanPipe implements PipeTransform {
  transform(plans: any[], searchText: string): any[] {
    if (!searchText) { return plans; }

    return plans.filter(plan => this.applyFilter(plan.name, searchText) // plan name
      || (plan.hasOwnProperty('createdByUser')
        && (
          this.applyFilter(plan.createdByUser.firstName, searchText) // created by user first name
          || this.applyFilter(plan.createdByUser.lastName, searchText) // created by user last name
          || this.applyFilter(plan.createdByUser.firstName.toLowerCase().concat(plan.createdByUser.lastName.toLowerCase()),
            searchText.replace(/ /g, '')) // combination of created by user first and last name
        )
      )
    );
  }

  /**
   * Asserts whether or not a text string is contained in a given value
   * @param {string} value search space
   * @param {string} filter search criteria
   */
  private applyFilter(value: string, filter: string): boolean {
    return value.toLowerCase().indexOf(filter.toLowerCase()) > -1;
  }
}
